import { render, staticRenderFns } from "./InjuryOnTheJob.vue?vue&type=template&id=6a433b37&scoped=true"
import script from "./InjuryOnTheJob.vue?vue&type=script&lang=js"
export * from "./InjuryOnTheJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a433b37",
  null
  
)

export default component.exports